export const BalanceType = {
    PTO: window.__GENERATED_CONSTANTS__.BalanceType.PTO,
    SICK: window.__GENERATED_CONSTANTS__.BalanceType.SICK
}

export default BalanceType



// WEBPACK FOOTER //
// ./web/js/enums/BalanceType.js